var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pack"},[_c('bkv-editor',{staticClass:"bkv-editor-holder",attrs:{"keyList":_vm.keyList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }